module.exports = __webpack_public_path__ + "static/themes-0ecbf811b4e9caacad9fbc6ee143317c.png";